module.exports = "/assets/data/bcaa063e8b7188fc3fcd3ca691c87d3e-RG5.data.json";